<template>
  <gadget-base @hide="hideWidget" v-loading="isLoading">
    <div class="chart bar">
      <h3>時間帯別売上</h3>
      <div class="chart_wrap" v-show="data.length">
        <canvas id="chart_3_1" ref="canvas"></canvas>
      </div>
      <div v-show="!data.length">
        データなし
      </div>
    </div>
  </gadget-base>
</template>

<script>
import GadgetBase from './GadgetBase'
import Chart from 'chart.js'
import addFigure from '@/misc/addFigure'

export default {
  name: 'TimeSalesBarChartGadget',
  props: {
    targetDate: {
      type: Object,
      required: true,
    },
  },
  watch: {
    targetDate (val) {
      this.fetchData()
    },
  },
  data () {
    return {
      isLoading: false,
      _chart: null,
      data: [],
    }
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.$request.reports.payments(this.targetDate.format('YYYY-MM-DD')).then(res => {
        const data = res.body.filter(x => x.type === 'record')
        if (!data.length) {
          this.data = []
        } else {
          const startHour = data[0].data.hour
          const endHour = data[data.length - 1].data.hour
          let ret = []
          for (let i = startHour; i <= endHour; i++) {
            const record = data.find(x => x.data.hour === i)
            if (record) {
              ret.push({
                label: `${i}:00`,
                data: record.data.sales,
                color: '#A1EBCB',
              })
            } else {
              ret.push({
                label: `${i}:00`,
                data: 0,
                color: '',
              })
            }
          }
          this.data = ret
        }
        this.createChart()
      }).finally(() => {
        this.isLoading = false
      })
    },
    createChart () {
      let data = {
        labels: this.data.map(x => x.label),
        datasets: [{
          backgroundColor: this.data.map(x => x.color),
          data: this.data.map(x => x.data),
        }],
      }
      if (this._chart) {
        this._chart.data = data
        this._chart.update()
        return
      }
      // let self = this
      this._chart = new Chart(this.$refs.canvas.getContext('2d'), {
        type: 'bar',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              },
            }],
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                return addFigure(tooltipItem.yLabel)
              },
            },
          },
        },
      })
    },
    hideWidget () {
      this.$emit('hide')
    },
  },
  mounted () {
    this.fetchData()
  },
  components: {
    GadgetBase,
  },
}
</script>

<style scoped>
div.chart {
  padding: 5px;
}

.chart h3 {
  font-size: 14px;
  font-weight: normal;
}

.chart_wrap {
  width: 100%;
  height: 400px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/TimeSalesBarChart.vue